import { render, staticRenderFns } from "./chatType.vue?vue&type=template&id=48761423&scoped=true&"
import script from "./chatType.vue?vue&type=script&lang=js&"
export * from "./chatType.vue?vue&type=script&lang=js&"
import style0 from "./chatType.vue?vue&type=style&index=0&id=48761423&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48761423",
  null
  
)

export default component.exports